import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ReactToPrint from "react-to-print";

import Row from "react-bootstrap/Row";

import QRCodeGenerator from "./QRCodeGenerator";
import { getNotes } from "../services/APIClient";

import "./PrintAllLoginsButton.css";

function PrintAllLoginsButton(props) {
  // let students = props.students;
  let name = props.name;
  let label = props.label;
  let classid = props.classid;
  let teachers = props.teachers || [];

  let qrCodeDetails = props.qrCodeDetails;
  let noteVersion = props.noteVersion ?? 0;

  let studentsQRDetails = [];
  if (qrCodeDetails) {
    qrCodeDetails.forEach((student) => {
      studentsQRDetails.push(student);
    });
  }

  studentsQRDetails.sort((a, b) => {
    let fa = a.name.toLowerCase(),
      fb = b.name.toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });

  const [notesData, setNotesData] = useState({ classNotes: [], studentNotes: [] });

  useEffect(() => {
    if (!classid) return;
    const fetchNotes = async () => {
      const [classNotesRes, ...studentNotesRes] = await Promise.all([
        getNotes('class', classid, 'QR Code'),
        ...studentsQRDetails.map((s) =>
          getNotes('student', s.studentid, 'QR Code').then((r) => ({ name: s.name, notes: r.data || [] }))
        ),
      ]);
      setNotesData({
        classNotes: classNotesRes.data || [],
        studentNotes: studentNotesRes.filter((s) => s.notes.length > 0),
      });
    };
    fetchNotes();
  }, [classid, qrCodeDetails, noteVersion]);

  const componentRef = useRef();

  // console.log(studentsQRDetails);

  // below is a terrible solution and I will properly fix
  // once things cool down a bit (06/10/22), Cathal

  function createPageBreak(qrId) {
    return function () {
      let qrCodeContainer = document.querySelectorAll(".qr-code-container");
      let newDiv = document.createElement("div");
      newDiv.className = "pagebreak";

      qrCodeContainer.forEach((qrCode, index) => {
        let qrCodeId = qrCode.getAttribute("data-qrid");
        if (qrCodeId == qrId) {
          qrCode.after(newDiv);
        }
      });
    };
  }

  const addPageBreakFunctions = [
    createPageBreak(11),
    createPageBreak(23),
    createPageBreak(35),
    createPageBreak(47),
    createPageBreak(59),
    createPageBreak(71),
    createPageBreak(83),
    createPageBreak(95),
    createPageBreak(107),
    createPageBreak(119),
    createPageBreak(131),
    createPageBreak(143),
    createPageBreak(155),
    createPageBreak(167),
    createPageBreak(179),
    createPageBreak(191),
  ];

  useEffect(() => {
    addPageBreakFunctions.forEach((addPageBreakFn) => {
      addPageBreakFn();
    });
  }, []);

  return (
    <>
      <QRPrintable
        students={studentsQRDetails}
        name={name}
        classNotes={notesData.classNotes}
        studentNotes={notesData.studentNotes}
        teachers={teachers}
        ref={componentRef}
      />

      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => (
          <button className="blue-button" style={{ borderRadius: "8px" }}>
            {props.label}
          </button>
        )}
      />
    </>
  );
}

function NoteItem({ note, teachers }) {
  const teacher = teachers.find((t) => t.id === note.teacherid);
  const teacherName = teacher?.name || 'Unknown';
  const dateStr = new Date(note.date_created).toLocaleString('en-IE', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Europe/Dublin',
  });

  return (
    <div style={{ marginBottom: '12px', padding: '10px 12px', borderLeft: '3px solid #1a56db', background: '#f8f9fa', borderRadius: '4px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
        {/* <span style={{ fontSize: '11px', fontWeight: 'bold', background: '#1a56db', color: 'white', padding: '2px 8px', borderRadius: '4px' }}>{note.note_type}</span> */}
        <span style={{ fontSize: '11px', color: '#666' }}>{teacherName} &bull; {dateStr}</span>
      </div>
      <div style={{ fontSize: '13px', color: '#333', whiteSpace: 'pre-wrap' }}>{note.note_text}</div>
    </div>
  );
}

const QRPrintable = React.forwardRef((props, ref) => (
  <div className="hide-div">
    <div ref={ref}>
      <Row className="qr-printout-margin">
        <h2 className="text-center printout-heading-fontsize">
          {props.name} Logins - alpaca-assessment.com
        </h2>
        {props.students.map((student, index) => (
          <QRCodeGenerator student={student} index={index} />
        ))}
      </Row>
      {(props.classNotes?.length > 0 || props.studentNotes?.length > 0) && (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '32px', maxWidth: '760px', margin: '0 auto', pageBreakBefore: 'always', color: '#1f2937' }}>
          <h1 style={{ borderBottom: '2px solid #1a56db', paddingBottom: '8px', color: '#1a56db', marginBottom: '4px' }}>{props.name} — Notes</h1>
          <p style={{ color: '#999', fontSize: '11px', marginBottom: '28px' }}>Printed: {new Date().toLocaleString('en-IE', { timeZone: 'Europe/Dublin' })}</p>
          {props.classNotes?.length > 0 && (
            <>
              <h2 style={{ color: '#333', marginTop: '0', marginBottom: '12px' }}>Class Notes</h2>
              {props.classNotes.map((note, i) => (
                <NoteItem key={i} note={note} teachers={props.teachers} />
              ))}
            </>
          )}
          {props.studentNotes?.length > 0 && (
            <>
              <h2 style={{ color: '#333', marginTop: '28px', marginBottom: '12px' }}>Student Notes</h2>
              {props.studentNotes.map((section, i) => (
                <div key={i}>
                  <h3 style={{ marginTop: '16px', marginBottom: '8px', color: '#444' }}>{section.name}</h3>
                  {section.notes.map((note, j) => (
                    <NoteItem key={j} note={note} teachers={props.teachers} />
                  ))}
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  </div>
));

export default PrintAllLoginsButton;
